// extracted by mini-css-extract-plugin
export var box = "_20-1";
export var checkboxRow = "_20-8";
export var checked = "_20-2";
export var descriptionSpacer = "_20-a";
export var disabled = "_20-3";
export var icon = "_20-6";
export var input = "_20-0";
export var labelSpacer = "_20-9";
export var medium = "_20-5";
export var small = "_20-4";
export var text = "_20-7";